import { PropsWithChildren } from 'react';
import { classNameList } from 'utils/property';
import styles from './Footer.module.scss';

interface IProps {
  className?: string;
}

export const Footer = ({ children, className }: PropsWithChildren<IProps>): JSX.Element => {
  return <div className={styles.footerWrapper}><div className={classNameList(styles.footer, className)}>{children}</div></div>;
};
